/* eslint-disable prettier/prettier */
import { api } from './axios';

export type SearchPagingParams = Partial<{
  takeUsers: number;    skipUsers: number;
  takeRoles: number;    skipRoles: number;
  takeFiles: number;    skipFiles: number;
  takeFolders: number;  skipFolders: number;
  takeInvitations: number; skipInvitations: number;
  takeCompanies: number;   skipCompanies: number;
}>;

export class DashboardService {
  static getStats() {
    return api.get('/dashboard/stats');
  }

  static async searchGlobally(query: string, params?: SearchPagingParams) {
    const response = await api.get('/search', {
      params: { query, ...(params || {}) },
    });
    return response.data;
  }

  static async searchMoreFor(
    query: string,
    entity:
      | 'users'
      | 'roles'
      | 'files'
      | 'folders'
      | 'invitations'
      | 'companies',
    take: number,
    skip = 0
  ) {
    const map: Record<string, SearchPagingParams> = {
      users: { takeUsers: take, skipUsers: skip },
      roles: { takeRoles: take, skipRoles: skip },
      files: { takeFiles: take, skipFiles: skip },
      folders: { takeFolders: take, skipFolders: skip },
      invitations: { takeInvitations: take, skipInvitations: skip },
      companies: { takeCompanies: take, skipCompanies: skip },
    };
    return this.searchGlobally(query, map[entity]);
  }
}
